import { render } from "./SectionTwo.vue?vue&type=template&id=27a8de32&ts=true"
import script from "./SectionTwo.vue?vue&type=script&lang=ts"
export * from "./SectionTwo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__